import React from 'react';

import { Help, styled, Typography } from '@gogame/components';

const OptionVisualContainer = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const DescriptionOptionTemplate = ({ name, description }) => (
  <OptionVisualContainer>
    <Typography noWrap disableTooltip>
      {name}
    </Typography>
    {description ? <Help>{description}</Help> : null}
  </OptionVisualContainer>
);
